<template>
  <div class="f-column">
    <GwTitleTooltip
      v-if="hasTitle"
      :title="$t('settings.trainer_back_pattern')"
      :tooltip="$t('tooltips.trainer_back_pattern')"
    />
    <SettingsColors
      :colorList="trainerTableColors"
      :enabledColors="['trainer_pattern']"
    />
    <div class="settings-cards-style settcrds mt-2">
      <!-- importing pattern svg is somehow bugged -->
      <div
        v-for="pt in options"
        :key="pt"
        class="settcrds_pt gw_btn"
        :class="[`back-pattern_${pt}`, { 'pt-style-active': selectedPattern === pt }]"
        @click="setPattern(pt)"
      >
        <div
          class="svg-back-pattern"
          style="color: var(--clr-black-1)"
        >
          <component :is="pt === 'none' ? 'div' : pt" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsColors from '@/components/Dialogs/UserSettingsDialog/SettingsColors'
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'

/* eslint-disable import/no-unresolved */
// import hexxa from '@/assets/patterns/1/hexxa.svg'
// import onions from '@/assets/patterns/1/onions.svg?skipsvgo'
import pokeball from '@/assets/patterns/1/pokeball.svg?skipsvgo'
import safari from '@/assets/patterns/1/safari.svg?skipsvgo'
import plus from '@/assets/patterns/1/plus.svg?skipsvgo'
import trianglemadness from '@/assets/patterns/1/trianglemadness.svg?skipsvgo'
import wavy from '@/assets/patterns/1/wavy.svg?skipsvgo'
import cubes from '@/assets/patterns/1/cubes.svg?skipsvgo'
import herringbone from '@/assets/patterns/1/herringbone.svg?skipsvgo'
import hexagon from '@/assets/patterns/1/hexagon.svg?skipsvgo'
import jigsaw from '@/assets/patterns/1/jigsaw.svg?skipsvgo'
import maya from '@/assets/patterns/1/maya.svg?skipsvgo'
import scales from '@/assets/patterns/1/scales.svg?skipsvgo'
import stars from '@/assets/patterns/1/stars.svg?skipsvgo'
import cloud from '@/assets/patterns/1/cloud.svg?skipsvgo'
import cube from '@/assets/patterns/1/cube.svg?skipsvgo'
import orient from '@/assets/patterns/1/orient.svg?skipsvgo'
import greek from '@/assets/patterns/1/greek.svg?skipsvgo'
import xmas from '@/assets/patterns/1/xmas.svg?skipsvgo'
import cogs from '@/assets/patterns/1/cogs.svg?skipsvgo'
import gwiz from '@/assets/patterns/1/gwiz.svg?skipsvgo'
/* eslint-enable */

export default {
  name: 'SettingsTrainerBackPattern',
  components: {
    SettingsColors,
    GwTitleTooltip,
    // 'hexxa',
    // 'onions',
    plus,
    trianglemadness,
    wavy,
    cubes,
    herringbone,
    hexagon,
    jigsaw,
    maya,
    safari,
    scales,
    stars,
    pokeball,
    cloud,
    cube,
    orient,
    greek,
    xmas,
    cogs,
    gwiz,
  },
  props: {
    hasTitle: { type: Boolean, default: true },
  },
  data() {
    this.options = [
      'none',
      // 'hexxa',
      // 'onions',
      'plus',
      'trianglemadness',
      'wavy',
      'cubes',
      'herringbone',
      'hexagon',
      'jigsaw',
      'maya',
      'safari',
      'scales',
      'stars',
      'pokeball',
      'cloud',
      'cube',
      'orient',
      'greek',
      'xmas',
      'cogs',
      'gwiz',
    ]
    return {}
  },
  methods: {
    setPattern(val) {
      this.$store.dispatch('userSettings', { traineBackPattern: val })
    },
    reset() {
      this.setTheme('default')
    },
  },
  computed: {
    trainerTableColors() {
      return this.$store.getters.mergedUserSettings.trainerTableColors
    },
    selectedPattern() {
      return this.$store.getters.mergedUserSettings.traineBackPattern
    },
  },
}
</script>

<style lang="scss" scoped>
.settcrds {
  display: grid;
  grid-template-columns: repeat(5, auto);
  grid-gap: 0.5rem;
  width: 100%;
  position: relativeZ;
  // --clr-svg: blue;
  // --clr-svg: var(--clr-trainer_pattern);
  // --clr-svg: var(--clr-black-1);
  // max-height: 12rem;
  // overflow: auto;
  &_pt {
    margin: 0 !important;
    height: 5rem;
    width: 3.5rem;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
  }
}
.svg-back-pattern {
  position: absolute;
  height: 100%;
  width: 100%;
  svg {
    position: absolute;
    height: 100%;
    width: 100%;
    // --clr-svg: var(--clr-trainer_pattern);
    color: currentColor;
  }
}
.pt-style-active {
  box-shadow: 0 0 0 2px var(--clr-primary);
}
</style>
